import * as React from "react";
import { Navigate, useLocation } from "react-router";
import { getCloudMetadata, getCurrentUser } from "./getCurrentUser";

const RETURN_PATH_KEY = "labelmaster.returnPath";

export function persistReturnPath(path: string) {
  try {
    sessionStorage.setItem(RETURN_PATH_KEY, path);
  } catch {
    // ignore
  }
}

export function consumeReturnPath(): string | null {
  try {
    const value = sessionStorage.getItem(RETURN_PATH_KEY);
    if (value) {
      sessionStorage.removeItem(RETURN_PATH_KEY);
    }
    return value;
  } catch {
    // ignore
  }
  return null;
}

export function redirectToSignIn(returnPath?: string) {
  const metadata = getCloudMetadata();
  if (returnPath) {
    persistReturnPath(returnPath);
  }
  if (metadata?.SignInUrl) {
    window.location.href = metadata.SignInUrl;
  }
}

type GuardProps = {
  children: React.ReactNode;
};

export function RequireAuth({ children }: GuardProps) {
  const location = useLocation();
  const user = getCurrentUser();

  React.useEffect(() => {
    if (!user) {
      redirectToSignIn(location.pathname + location.search);
    }
  }, [user, location.pathname, location.search]);

  if (!user) {
    return <p>Redirecting to sign in…</p>;
  }

  return <>{children}</>;
}

export function RequireAdmin({ children }: GuardProps) {
  const location = useLocation();
  const user = getCurrentUser();

  React.useEffect(() => {
    if (!user) {
      redirectToSignIn(location.pathname + location.search);
    }
  }, [user, location.pathname, location.search]);

  if (!user) {
    return <p>Redirecting to sign in…</p>;
  }

  if (!user.IsAdmin) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}
